import GTM from '../gtm/GTM';
import GTMExperienceImpressionModel from '../gtm/models/GTMExperienceImpressionModel';

export interface ExperimentData {
    [key: string]: number | string;
}

class ExperimentReporter {
    public track(experiments: ExperimentData): void {
        const entries = Object.entries(experiments) || [];
        entries.forEach(([experimentId, variant]): void => {
            GTM.track(
                GTMExperienceImpressionModel.parseToGTMData({
                    experiment: experimentId,
                    variant: String(variant)
                })
            );
        });
    }
}

export default new ExperimentReporter();
